import { createContext, useContext } from 'react';
import SSoTMessageEmitter from '@utils/eventHandler';
const emitter = new SSoTMessageEmitter();
export const EventEmitterContext = createContext(emitter);

export const useMessageEmitter = () => useContext(EventEmitterContext);
